module.exports = __webpack_public_path__ + "media/highclass/top-image-tbsp-9fb34635.webp";